// @flow strict

export { default as getFilteredLineData } from "./filter";
export { default as getFindResults } from "./search";
export { default as getHighlights } from "./highlights";



// WEBPACK FOOTER //
// ./src/selectors/lines/index.js